import React from 'react';

const Portfolio2 = () => {
	return (
		<div>
			<h1>Mail us on feedback@geeksforgeeks.org</h1>
		</div>
	);
};

export default Portfolio2;